import { useEffect, useState } from 'react';

/*
  NOTES: 

  - react-player component is poorly adapted to play multiple URLs.
    This component is designed to neutralize this problem.

  - 'init' is the first onReady effect when changing the URL.
    When 'init === true' the media can seek

  - url cannot be changed until 'init === true'
*/

export const usePlayerInit = (url?: Url, cb?: (init: boolean) => void) => {
  const [listenUrl, setListenUrl] = useState(false);
  const [initPlayer, setInitPlayer] = useState(false);
  const [src, setSrc] = useState('');

  useEffect(() => {
    if (!src) {
      setSrc(url ?? '');
      setInitPlayer(false);
    } else setListenUrl(true);
  }, [url]);

  useEffect(() => {
    if (!listenUrl) return;
    if (initPlayer) {
      setSrc(url ?? '');
      setListenUrl(false);
      setInitPlayer(url ? false : true);
    }
  }, [listenUrl, initPlayer]);

  useEffect(() => {
    if (cb) cb(initPlayer);
  }, [initPlayer]);

  return { src, listenUrl, setInitPlayer };
};
